import React from 'react';
import EmptyPage from '../EmptyPage';

const TodoPage: React.FC = () => {
  return (
    <EmptyPage
      title="해야 할 일"
      icon="CheckSquare"
      description="할 일 목록과 작업 관리 기능을 제공합니다."
      parentTitle="대시보드"
    />
  );
};

export default TodoPage;
